"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var layout = _ref.layout,
        onError = _ref.onError,
        onWarning = _ref.onWarning;

    return layout;
};
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/validators/dhis/index.js
 ** module id = 220
 ** module chunks = 0 1
 **/